export default import.meta.ROLLDOWN_FILE_URL_Kzm4UjIgA1kMLjKeA0Qcvg